import React from 'react';
import PropTypes from 'prop-types';

import IU from '../../../_utils/img/img-utils';
import DpiNotice from './dpi-notice';
import { PrintSize, PhotoDimensions } from '../../prop-types';

// eslint-disable-next-line camelcase
const PhotoDpiNotice = ({ noText, tooltipPosition, tooltipCSSClasses, hideTooltip, recommendedPrintSize, size_area, raw_dimensions }) => (
  <DpiNotice
    dpi={IU.imgHelpers.getPhotoDPI({ size_area, raw_dimensions })}
    noText={!!noText}
    tooltipPosition={tooltipPosition}
    tooltipCSSClasses={tooltipCSSClasses}
    recommendedPrintSize={recommendedPrintSize}
    hideTooltip={hideTooltip}
  />
);

PhotoDpiNotice.propTypes = {
  size_area: PropTypes.arrayOf(PropTypes.number).isRequired,
  raw_dimensions: PhotoDimensions.isRequired,
  noText: PropTypes.bool,
  tooltipPosition: PropTypes.string,
  tooltipCSSClasses: PropTypes.string,
  recommendedPrintSize: PrintSize,
  hideTooltip: PropTypes.bool,
}

PhotoDpiNotice.defaultProps = {
  noText: false,
  tooltipPosition: undefined,
  tooltipCSSClasses: undefined,
  hideTooltip: false,
  recommendedPrintSize: null,
}

export default PhotoDpiNotice;
